import "./ProductScreen1.css";

const ProductScreen1 = () => {
  return (
    <div className="product-screen-2">
      <img
        className="background-blobs-icon3"
        alt=""
        src="/backgroundblobs.svg"
      />
      <div className="navbar2">
        <div className="backlogo410" />
        <b className="contact2">Contact</b>
        <b className="about-us2">About Us</b>
        <b className="products2">Products</b>
        <b className="home10">Home</b>
        <img className="navbar-child" alt="" src="/line-2.svg" />
      </div>
      <div className="shop1">
        <div className="row-21">
          <div className="backlogo411" />
          <div className="backlogo412" />
          <div className="backlogo413" />
          <img className="backlogo4-icon2" alt="" src="/backlogo4.svg" />
          <b className="ezee-black-garbage">
            Ezee Black Garbage Bags for Dustbin | 90 Pcs | Medium 19 X 21 Inches
            | 30 Pcs x Pack of 3
          </b>
          <img className="image-5-icon2" alt="" src="/image-51@2x.png" />
          <b className="redragon-k617-fizz">
            Redragon K617 Fizz 60% Wired RGB Gaming Keyboard, 61 Keys Compact
            Mechanical Keyboard
          </b>
          <img className="image-6-icon2" alt="" src="/image-6@2x.png" />
          <b className="qizlar-extended-gaming">
            Qizlar Extended Gaming Mouse Pad | Extra Large Mouse Mat for Gamer
          </b>
          <img className="image-7-icon2" alt="" src="/image-7@2x.png" />
          <b className="wild-stone-code">
            Wild Stone Code Titanium Body Perfume for Men, 120ml
          </b>
          <img className="image-8-icon2" alt="" src="/image-8@2x.png" />
        </div>
        <div className="row-31">
          <div className="backlogo411" />
          <div className="backlogo412" />
          <div className="backlogo413" />
          <img className="backlogo4-icon2" alt="" src="/backlogo4.svg" />
          <b className="lg-electronics-ultragear-27gp7">
            LG Electronics Ultragear-27Gp750-B Full Hd IPS,27 Inch(68.5 Cm) 240
            Hz Nvidia G-Sync Compatible,Freesync Premium,LCD,1920 X 1080
            Pixels(…
          </b>
          <img className="image-5-icon3" alt="" src="/image-52@2x.png" />
          <b className="redragon-k617-fizz">
            <p className="himalaya-wellness-pure-herbs-m">
              <a
                className="himalaya-wellness-pure"
                href={`https://www.amazon.in/Himalaya-Wellness-Herbs-Meshashringi-Metabolic/dp/B006FE0JJ2?pd_rd_w=4ezSl&content-id=amzn1.sym.29b45bd4-f0c3-4ec8-9fe3-0244fb94c268&pf_rd_p=29b45bd4-f0c3-4ec8-9fe3-0244fb94c268&pf_rd_r=RSG126QVBFYRR7M2560W&pd_rd_wg=UzBDf&pd_rd_r=9bc68698-bc04-4ac0-9316-9dab96359c71&pd_rd_i=B006FE0JJ2&psc=1&ref_=pd_bap_d_grid_rp_0_1_ec_nped_pd_gwd_bag_pd_gw_rp_2_t`}
                target="_blank"
              >
                Himalaya Wellness Pure Herbs Meshashringi Metabolic Wellness -
                60 Tablet
              </a>
            </p>
            <p className="himalaya-wellness-pure-herbs-m">
              60 Count (Pack of 1)
            </p>
          </b>
          <img className="image-6-icon3" alt="" src="/image-61@2x.png" />
          <b className="lakme-absolute-skin">
            Lakme Absolute Skin Natural Mousse Golden Light 04, SPF8 Natural
            Finish Matte Cream Foundation -Long Lasting Weightless Full Coverage
            Face Makeup,....
          </b>
          <img className="image-7-icon2" alt="" src="/image-71@2x.png" />
          <a
            className="engage-woman-deodorant"
            href={`https://www.amazon.in/Engage-Woman-Deodorant-Tease-Pack/dp/B087TY9PHD?pd_rd_w=hAyl1&content-id=amzn1.sym.29b45bd4-f0c3-4ec8-9fe3-0244fb94c268&pf_rd_p=29b45bd4-f0c3-4ec8-9fe3-0244fb94c268&pf_rd_r=AKMGFBR5ABRG49565PZP&pd_rd_wg=0bkbl&pd_rd_r=26190a20-5ea7-48a4-911a-7903b8d02a15&pd_rd_i=B087TY9PHD&psc=1&ref_=pd_bap_d_grid_rp_0_5_t`}
            target="_blank"
          >
            Engage Woman Deodorant, Tease, 150 ml (Pack of 3)
          </a>
          <img className="image-8-icon3" alt="" src="/image-81@2x.png" />
        </div>
        <div className="header1" />
      </div>
      <div className="main-logo4">
        <div className="logo-black4" />
        <b className="robiz4">roBiz</b>
        <b className="netze4">NetZe</b>
      </div>
      <div className="login4">
        <div className="login-brown2" />
        <b className="login5">LOGIN</b>
      </div>
      <div className="search-bar2">
        <div className="backlogo417" />
        <b className="search-products2">Search Products</b>
        <img className="frame-icon1" alt="" src="/frame.svg" />
      </div>
      <div className="filters4">
        <div className="back2" />
        <div className="filter-section1">
          <b className="filters5">Filters</b>
          <div className="component-2">
            <img className="checkbox-icon12" alt="" src="/checkbox6.svg" />
            <b className="laptop">Laptop</b>
          </div>
          <img className="checkbox-icon13" alt="" src="/checkbox7.svg" />
          <b className="clothing2">Clothing</b>
          <img className="checkbox-icon14" alt="" src="/checkbox6.svg" />
          <b className="clothing2">Electronics</b>
          <img className="checkbox-icon14" alt="" src="/checkbox6.svg" />
          <b className="clothing2">Grocery</b>
          <img className="checkbox-icon14" alt="" src="/checkbox6.svg" />
          <b className="clothing2">Health</b>
        </div>
        <div className="color-circle">
          <img className="vector-icon7" alt="" src="/vector5.svg" />
          <img className="vector-icon8" alt="" src="/vector5.svg" />
          <img className="vector-icon9" alt="" src="/vector5.svg" />
          <img className="vector-icon10" alt="" src="/vector5.svg" />
          <img className="vector-icon11" alt="" src="/vector5.svg" />
          <img className="vector-icon12" alt="" src="/vector5.svg" />
          <img className="vector-icon13" alt="" src="/vector5.svg" />
          <img className="vector-icon14" alt="" src="/vector5.svg" />
          <img className="vector-icon15" alt="" src="/vector5.svg" />
          <img className="vector-icon16" alt="" src="/vector5.svg" />
          <img className="vector-icon7" alt="" src="/vector5.svg" />
          <img className="vector-icon8" alt="" src="/vector5.svg" />
          <img className="vector-icon9" alt="" src="/vector5.svg" />
          <img className="vector-icon10" alt="" src="/vector5.svg" />
          <img className="vector-icon11" alt="" src="/vector5.svg" />
          <b className="color3">Color</b>
        </div>
        <b className="price">Price</b>
        <img className="price-icon1" alt="" src="/price-icon.svg" />
        <div className="price-section1">
          <img className="line-icon" alt="" src="/line-1.svg" />
          <div className="ellipse-div" />
          <div className="rectangle-div" />
          <b className="b3">$0</b>
          <b className="b4">$1000</b>
          <b className="b5">$69</b>
        </div>
        <div className="area">
          <div className="location" />
          <b className="area1">Area</b>
          <b className="choose-location">choose location</b>
        </div>
      </div>
    </div>
  );
};

export default ProductScreen1;
